import { render, staticRenderFns } from "./ConcertText.vue?vue&type=template&id=30676574"
import script from "./ConcertText.vue?vue&type=script&lang=js"
export * from "./ConcertText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports